exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".warning {\r\n    color: blue;\r\n}\r\n\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/main/customApplicationCreation/custom-application-creation.component.css
 ** module id = 1098
 ** module chunks = 2
 **/